// @flow

import React from 'react'
import Tooltip from './Tooltip'

type Props = {
  children?: React$Node,
  className?: string,
  colorClass?: string,
  arrowClass?: string,
  backgroundClass?: string,
  tip: React$Node,
}

type State = {
  hovered: boolean,
}

export default class HoverTooltip extends React.Component<Props, State> {
  state = {
    hovered: false,
  }

  toggleHover() {
    this.setState({ hovered: !this.state.hovered })
  }

  render() {
    const {
      children,
      className = '',
      colorClass = '',
      arrowClass = '',
      backgroundClass = '',
      tip,
    } = this.props

    return (
      <div
        className={`${className} relative `}
        onMouseOver={() => this.toggleHover()}
        onMouseOut={() => this.toggleHover()}
      >
        {children}
        <Tooltip
          show={this.state.hovered}
          colorClass={colorClass}
          arrowClass={arrowClass}
          backgroundClass={backgroundClass}
        >
          {tip}
        </Tooltip>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Controls/HoverTooltip.js